import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">热门话题</h2>
          <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">实时热度</span>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 bg-background-100 hover:bg-accent-50 rounded-full border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-colors">
                <i className={`${topic.icon} text-sm md:text-base`}></i>
              </span>
              <div className="flex flex-col items-start">
                <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-foreground-900 whitespace-nowrap">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}